export const formStructureBuilder = (data) => {
  const structure = {};

  Object.entries(data).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (value.length === 0) {
        structure[key] = {
          type: "emptyArray",
          isArray: true,
          items: [],
        };
      } else if (
        value.length > 0 &&
        typeof value[0] === "object" &&
        value[0] !== null
      ) {
        // Array of objects
        structure[key] = {
          type: "arrayOfObjects",
          isArray: true,
          fields: Object.keys(value[0]),
          items: value,
        };
      } else {
        // Simple array
        structure[key] = {
          type: "simpleArray",
          isArray: true,
          items: value,
        };
      }
    } else if (typeof value === "object" && value !== null) {
      if (Object.keys(value).length === 0) {
        structure[key] = {
          type: "emptyObject",
          isArray: false,
          value: {},
        };
      } else {
        structure[key] = {
          type: "object",
          isArray: false,
          value: value,
        };
      }
    } else if (value === null || value === undefined) {
      structure[key] = {
        type: "null",
        isArray: false,
        value: "N/A",
      };
    } else {
      structure[key] = {
        type: "text",
        isArray: false,
        value: value,
      };
    }
  });

  return structure;
};

// Helper function to format field names for display
export const formatFieldName = (fieldName) => {
  const normalized = String(fieldName || "")
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  // Keep acronym-style keys unchanged (e.g., CNAME, DOE, RROLL).
  if (/^[A-Z0-9 ]+$/.test(normalized)) {
    return normalized;
  }

  return normalized
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .replace(/^./, (str) => str.toUpperCase());
};
